import React from "react";
import KidexContainer from "./KidexContainer";
import studenDevCrd from "../../../Assets/landing-page/student-dev-card.svg";
import studenDevCrd2 from "../../../Assets/landing-page/student-dev-card2.svg";
import studenDevCrd3 from "../../../Assets/landing-page/student-dev-card3.svg";
import studenDevCrd4 from "../../../Assets/landing-page/student-dev-card4.svg";
import studenDevCrd5 from "../../../Assets/landing-page/student-dev-card5.svg";
import studenDevCrd6 from "../../../Assets/landing-page/student-dev-card6.svg";

const StudentDevelopment = () => {
   return (
      <React.Fragment>
         <section className="student-development-sec outer-space">
            <div className="sec-main-heading">
               KidEx is your ideal partner to drive <br />
               Holistic Development of Students
            </div>
            <div className="student-dvlpmtn-card-outer">
               <KidexContainer>
                  <div className="student-dvlpmtn-cards">
                     <div className="student-dvlpmtn-card">
                        <div className="student-dvlpmtn-card-img">
                           <img src={studenDevCrd} />
                        </div>
                        <p className="img-title">Maximum number of programs</p>
                     </div>
                     <div className="student-dvlpmtn-card">
                        <div className="student-dvlpmtn-card-img">
                           <img src={studenDevCrd2} />
                        </div>
                        <p className="img-title">Highest quality rated consistently</p>
                     </div>
                     <div className="student-dvlpmtn-card">
                        <div className="student-dvlpmtn-card-img">
                           <img src={studenDevCrd3} />
                        </div>
                        <p className="img-title">Most affordable pricing</p>
                     </div>
                     <div className="student-dvlpmtn-card">
                        <div className="student-dvlpmtn-card-img">
                           <img src={studenDevCrd4} />
                        </div>
                        <p className="img-title">Complete variable pricing</p>
                     </div>
                     <div className="student-dvlpmtn-card">
                        <div className="student-dvlpmtn-card-img">
                           <img src={studenDevCrd5} />
                        </div>
                        <p className="img-title">Near zero overhead for your team</p>
                     </div>
                     <div className="student-dvlpmtn-card">
                        <div className="student-dvlpmtn-card-img">
                           <img src={studenDevCrd6} />
                        </div>
                        <p className="img-title">
                           Expert and reliable team of India’s best
                        </p>
                     </div>
                  </div>
               </KidexContainer>
            </div>
         </section>
      </React.Fragment>
   );
};
export default StudentDevelopment;
